const component = "date-range-picker";

export const dateRangePicker = {
  component,
  cancelBtn: `${component}/cancel-button`,
  submitBtn: `${component}/submit-button`,
};
